import {
  statusMappings,
  fixDateFormat,
  colorMappings,
} from "../../../components/pc/Utils.js";
import LabelExistingWo from "../controls/LabelExistingWo.js";
import TextBoxExistingWo from "../controls/TextBoxExistingWo.js";
import TextBoxDateTime from "../controls/TextBoxDateTime.js";
import { useState, useEffect } from "react";
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import waitonCreate from "../../../assets/load.gif";
import { Table } from "react-bootstrap";
import { useClarityEventTracking } from "../hooks/useClarityTracking";
import { format } from "date-fns";


const TabOverView = ({
  woDetails,
  woUpdateData,
  setWoUpdateData,
  saveUpdate,
  user = "",
  setUpdateMsg,
  updateMsg,
  setIsUpdating,
  isUpdating,
  getParameterValue,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [cancelText, setCancelText] = useState("");
  const [isErr, setIsErr] = useState(false);

  const trackEvent = useClarityEventTracking();

  const [dateErr, setDateErr] = useState({
    requiredStartDate: false,
    requiredEndDate: false,
  });
  const [startLaterThanEnd, setStartLaterThanEnd] = useState(false);

  const editableStates = [
    "FAULTREPORT",
    "OBSERVED",
    "WORKREQUEST",
    "UNDERPREPARATION",
    "RELEASED",
  ];
  const isTimeEditable = editableStates.includes(woDetails[0].OBJSTATE);

  const originalStart = new Date(woDetails[0].REQUIRED_START_DATE);
  const originalEnd = new Date(woDetails[0].REQUIRED_END_DATE);

  function validate() {
    let ret = false;
    if (!/^\+?[0-9]*$/.test(woUpdateData.clientPhone)) {
      setIsErr(true);
      ret = true;
    } else {
      setIsErr(false);
    }

    // Validate dates
    let startValid = true;
    let endValid = true;
    setStartLaterThanEnd(false);

    if (woUpdateData.requiredStartDate) {
      const newStart = new Date(woUpdateData.requiredStartDate);
      if (newStart < originalStart) {
        setDateErr((prev) => ({ ...prev, requiredStartDate: true }));
        startValid = false;
      } else {
        setDateErr((prev) => ({ ...prev, requiredStartDate: false }));
      }
    }

    if (woUpdateData.requiredEndDate) {
      const newEnd = new Date(woUpdateData.requiredEndDate);
      if (newEnd < originalEnd) {
        setDateErr((prev) => ({ ...prev, requiredEndDate: true }));
        endValid = false;
      } else {
        setDateErr((prev) => ({ ...prev, requiredEndDate: false }));
      }
    }

    // Start date cannot be later than end date
    if (
      startValid &&
      woUpdateData.requiredStartDate &&
      woUpdateData.requiredEndDate
    ) {
      const newStart = new Date(woUpdateData.requiredStartDate);
      const newEnd = new Date(woUpdateData.requiredEndDate);
      if (newStart > newEnd) {
        setDateErr((prev) => ({ ...prev, requiredStartDate: true }));
        setStartLaterThanEnd(true);
        startValid = false;
      } else {
        setDateErr((prev) => ({ ...prev, requiredStartDate: false }));
      }
    }

    return ret || !startValid || !endValid;
  }

  const edit = (e) => {
    setIsEdit(!isEdit);
    setUpdateMsg({ ...updateMsg, isOk: false, message: "" });
    trackEvent("Översikt - Uppdatera AO");
  };

  const cancel = (e) => {
    setIsCancel(!isCancel);
  };

  const formatDate = (date) => {
    return format(date, "yyyy-MM-dd HH:mm");
  };

  const saveWo = () => {
    console.log("Save");
    if (validate() === false) {
      setIsUpdating(true);
      setUpdateMsg({ ...updateMsg, isOk: false, message: "" });

      // Add log entry for date changes
      const hasStartDateChange =
        woUpdateData.requiredStartDate &&
        new Date(woUpdateData.requiredStartDate).getTime() !==
          originalStart.getTime();
      const hasEndDateChange =
        woUpdateData.requiredEndDate &&
        new Date(woUpdateData.requiredEndDate).getTime() !==
          originalEnd.getTime();

      if (hasStartDateChange || hasEndDateChange) {
        const currentDate = new Date().toISOString().split("T")[0];
        const logEntry = `Uppdatering ${currentDate}: Arbetsorder uppdaterad med `;

        const parts = [];
        if (hasStartDateChange) {
          const formattedStart = formatDate(woUpdateData.requiredStartDate);
          parts.push(`ny önskad starttid: ${formattedStart}`);
        }
        if (hasEndDateChange) {
          const formattedEnd = formatDate(woUpdateData.requiredEndDate);
          parts.push(`ny önskad stopptid: ${formattedEnd}`);
        }

        const logMessage = `${logEntry}${parts.join(
          " och "
        )} Ändringen utförd av användare: ${user}`;
        const newWorkDesc = `${logMessage}\n\r\n\r${woDetails[0].WORK_DESCR_LO}`;

        setWoUpdateData((prev) => ({
          ...prev,
          longWorkDesc: newWorkDesc,
          triggerSave: true,
        }));
      } else {
        saveUpdate();
      }
    }
  };

  useEffect(() => {
    if (woUpdateData.triggerSave) {
      setWoUpdateData((prev) => ({
        ...prev,
        triggerSave: false,
      }));
      saveUpdate();
    }
  }, [woUpdateData.triggerSave, saveUpdate]);

  useEffect(() => {
    console.log(woUpdateData);
    if (woUpdateData.test1 === "CANCEL") {
      saveUpdate();
      setWoUpdateData({
        ...woUpdateData,
        test1: "",
      });
    }
  }, [woUpdateData]);

  const saveCancelWo = (e) => {
    console.log("SaveCancel");
    console.log("Save");
    let date = new Date().toLocaleString() + "";
    let tmp = "Makulering av " + user + " - " + date + "\n\r" + cancelText;
    let workDescr = tmp + "\n\r\n\r" + woDetails[0].WORK_DESCR_LO;
    setWoUpdateData({
      ...woUpdateData,
      cancelReason: tmp,
      longWorkDesc: workDescr,
      test1: "CANCEL",
      messageType: "CANCEL",
    });
  };

  function cancelReasonChange(evt) {
    //setWoUpdateData({ ...woUpdateData, longWorkDesc: evt.target.value })
    setCancelText(evt.target.value);
  }

  useEffect(() => {
    validate();
  }, [woUpdateData.requiredStartDate, woUpdateData.requiredEndDate]);

  if (isEdit) {
    return (
      <>
        <Table responsive="lg" className="table1" borderless="true">
          <tbody>
            <tr>
              <td colSpan={2}>
                <FaEdit
                  id="faediticon"
                  data-tooltip-content="Ändra data"
                  onClick={edit}
                  className="faEdit"
                />
                <Tooltip
                  anchorId="faediticon"
                  multiline={true}
                  data-html={true}
                />
              </td>
            </tr>
            <tr>
              <td>
                <LabelExistingWo
                  text={fixDateFormat(woDetails[0].REG_DATE)}
                  headerText="Skapad"
                  jsonText="createdtime"
                />
              </td>
              <td>
                <LabelExistingWo
                  text={woDetails[0].REFERENCE_NO}
                  headerText="Referensnummer"
                  jsonText="refnr"
                />
              </td>
            </tr>
            <tr>
              <td>
                <LabelExistingWo
                  text={statusMappings(
                    woDetails[0].OBJSTATE,
                    getParameterValue("9090"),
                    woDetails[0].KUND_MAK
                  )}
                  headerText="Status"
                  jsonText="state"
                  css={colorMappings(
                    woDetails[0].OBJSTATE,
                    getParameterValue("9090"),
                    woDetails[0].KUND_MAK
                  )}
                />
              </td>
              <td> </td>
            </tr>
            <tr>
              <td>
                <LabelExistingWo
                  text={woDetails[0].KOMMUN}
                  headerText="Kommun"
                  jsonText="kommun"
                />
              </td>
              <td>
                <LabelExistingWo
                  text={getParameterValue("9801")}
                  headerText="Produkt"
                  jsonText="produkt"
                />
              </td>
            </tr>
            <tr>
              <td>
                <TextBoxExistingWo
                  headerText="Kontaktperson"
                  text={woUpdateData}
                  setText={setWoUpdateData}
                  jsonText="clientContact"
                  maxLength="30"
                />
              </td>
              <td>
                <TextBoxExistingWo
                  headerText="Telefon"
                  text={woUpdateData}
                  setText={setWoUpdateData}
                  jsonText="clientPhone"
                  maxLength="13"
                  isErr={isErr}
                  errText="Obligatorisk, 0-9 och +"
                />
              </td>
            </tr>
            <tr>
              <td>
                {isTimeEditable ? (
                  <TextBoxDateTime
                    headerText="Önskad starttid"
                    text={woUpdateData}
                    setText={setWoUpdateData}
                    jsonText="requiredStartDate"
                    validateIsErr={dateErr}
                    errText={
                      startLaterThanEnd
                        ? "Önskad starttid kan inte vara senare än Önskad sluttid"
                        : "Kan ej sätta tidigare tid än ursprungligt begärt"
                    }
                    toolTip="Här väljer du önskad tid för när Eltel ska påbörja jobbet i fält.<br />Obs! Vid avtalad SLA ska jobbet påbörjas vid denna tid."
                    defaultValue={fixDateFormat(
                      woDetails[0].REQUIRED_START_DATE
                    )}
                  />
                ) : (
                  <LabelExistingWo
                    text={fixDateFormat(woDetails[0].REQUIRED_START_DATE)}
                    headerText="Önskad starttid"
                    jsonText=""
                  />
                )}
              </td>
              <td>
                {isTimeEditable ? (
                  <TextBoxDateTime
                    headerText="Önskad sluttid"
                    text={woUpdateData}
                    setText={setWoUpdateData}
                    jsonText="requiredEndDate"
                    validateIsErr={dateErr}
                    errText="Kan ej sätta tidigare tid än ursprungligt begärt"
                    toolTip="Här väljer du önskad klar tid för när Eltel ska slutföra jobbet i fält.<br />Obs vid avtalad SLA ska jobbet slutföras enligt avtalets direktiv."
                    defaultValue={fixDateFormat(woDetails[0].REQUIRED_END_DATE)}
                  />
                ) : (
                  <LabelExistingWo
                    text={fixDateFormat(woDetails[0].REQUIRED_END_DATE)}
                    headerText="Önskad sluttid"
                    jsonText=""
                  />
                )}
              </td>
            </tr>
            <tr>
              <td>
                <LabelExistingWo
                  text={fixDateFormat(woDetails[0].REAL_S_DATE)}
                  headerText="Verklig start"
                  jsonText=""
                />
              </td>
              <td>
                <LabelExistingWo
                  text={fixDateFormat(woDetails[0].REAL_F_DATE)}
                  headerText="Verklig slut"
                  jsonText=""
                />
              </td>
            </tr>
            <tr>
              <td>
                <LabelExistingWo
                  text={fixDateFormat(woDetails[0].PLAN_S_DATE)}
                  headerText="Planerad start"
                  jsonText=""
                />
              </td>
              <td>
                <LabelExistingWo
                  text={fixDateFormat(woDetails[0].PLAN_F_DATE)}
                  headerText="Planerad slut"
                  jsonText=""
                />
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <LabelExistingWo
                  text={getParameterValue("8134")}
                  headerText="Order skapad av"
                  jsonText=""
                />
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <button
                  className="btn btnUpd"
                  onClick={saveWo}
                  disabled={
                    isUpdating ||
                    isErr ||
                    dateErr.requiredStartDate ||
                    dateErr.requiredEndDate
                  }
                >
                  Spara
                </button>
                <div>{updateMsg.message}</div>
                {isUpdating ? (
                  <img
                    src={waitonCreate}
                    alt="loading..."
                    className="loadGifsmall"
                  />
                ) : (
                  <></>
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </>
    );
  } else {
    if (isCancel) {
      return (
        <>
          <Table responsive="lg" className="table1" borderless="true">
            <tbody>
              <tr>
                <td colSpan={2}>
                  <FaEdit
                    id="faediticon"
                    data-tooltip-content="Ändra data"
                    onClick={cancel}
                    className="faEdit"
                  />
                  <Tooltip
                    anchorId="faediticon"
                    multiline={true}
                    data-html={true}
                  />
                  <FaRegTrashAlt
                    id="facancelicon"
                    data-tooltip-content="Makulera ärende"
                    onClick={cancel}
                    className="faEdit"
                  />
                  <Tooltip
                    anchorId="facancelicon"
                    multiline={true}
                    data-html={true}
                  />
                </td>
              </tr>
              <tr>
                <td>Makulera ärende</td>
                <td> </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <textarea
                    id="txtAreaAdd"
                    value={cancelText}
                    onChange={cancelReasonChange}
                    name="cancelTxt"
                    className="txtAreaExisting"
                    rows="3"
                    cols="100"
                  ></textarea>
                </td>
              </tr>
              <tr>
                <td>
                  <button
                    className="btn"
                    onClick={saveCancelWo}
                    disabled={cancelText.length === 0 ? true : false}
                  >
                    Spara
                  </button>
                </td>
                <td> </td>
              </tr>
            </tbody>
          </Table>
        </>
      );
    } else {
      return (
        <>
          <Table
            responsive="lg"
            className="table1 align-items-center"
            borderless="true"
          >
            <tbody>
              {woDetails[0].OBJSTATE !== "FINISHED" && (
                <tr>
                  <td colSpan={2}>
                    <FaEdit
                      id="faediticon"
                      data-tooltip-content="Ändra data"
                      onClick={edit}
                      className="faEdit"
                      style={{ marginRight: "10px" }}
                    />
                    <Tooltip
                      anchorId="faediticon"
                      multiline={true}
                      data-html={true}
                    />
                    <FaRegTrashAlt
                      id="facancelicon"
                      data-tooltip-content="Makulera ärende"
                      onClick={cancel}
                      className="faEdit"
                    />
                    <Tooltip
                      anchorId="facancelicon"
                      multiline={true}
                      data-html={true}
                    />
                  </td>
                </tr>
              )}
              <tr>
                <td>
                  <LabelExistingWo
                    text={fixDateFormat(woDetails[0].REG_DATE)}
                    headerText="Skapad"
                    jsonText="createdtime"
                  />
                </td>
                <td>
                  <LabelExistingWo
                    text={woDetails[0].REFERENCE_NO}
                    headerText="Referensnummer"
                    jsonText="refnr"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <LabelExistingWo
                    text={statusMappings(
                      woDetails[0].OBJSTATE,
                      getParameterValue("9090"),
                      woDetails[0].KUND_MAK
                    )}
                    headerText="Status"
                    jsonText="state"
                    css={colorMappings(
                      woDetails[0].OBJSTATE,
                      getParameterValue("9090"),
                      woDetails[0].KUND_MAK
                    )}
                  />
                </td>
                <td>
                  <LabelExistingWo
                    text={
                      woDetails[0].EXECUTE_BY !== ""
                        ? woDetails[0].EXECUTE_BY
                        : "Tekniker ej tillsatt"
                    }
                    headerText="Tekniker på jobbet"
                    jsonText="executeBy"
                  />
                  <LabelExistingWo
                    text={woDetails[0].EXECUTE_BY_MOBILE}
                    headerText=""
                    jsonText="executeByMobile"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <LabelExistingWo
                    text={woDetails[0].KOMMUN}
                    headerText="Kommun"
                    jsonText="kommun"
                  />
                </td>
                <td>
                  <LabelExistingWo
                    text={getParameterValue("9801")}
                    headerText="Produkt"
                    jsonText="produkt"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <LabelExistingWo
                    text={woDetails[0].CONTACT}
                    headerText="Kontaktperson"
                    jsonText="contactp"
                  />
                </td>
                <td>
                  <LabelExistingWo
                    text={woDetails[0].PHONE_NO}
                    headerText="Telefonnummer"
                    jsonText="telcontact"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <LabelExistingWo
                    text={fixDateFormat(woDetails[0].REQUIRED_START_DATE)}
                    headerText="Önskad starttid"
                    jsonText="requiredStartDate"
                  />
                </td>
                <td>
                  <LabelExistingWo
                    text={fixDateFormat(woDetails[0].REQUIRED_END_DATE)}
                    headerText="Önskad sluttid"
                    jsonText="requiredEndDate"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <LabelExistingWo
                    text={fixDateFormat(woDetails[0].REAL_S_DATE)}
                    headerText="Verklig start"
                    jsonText=""
                  />
                </td>
                <td>
                  <LabelExistingWo
                    text={fixDateFormat(woDetails[0].REAL_F_DATE)}
                    headerText="Verklig slut"
                    jsonText=""
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <LabelExistingWo
                    text={fixDateFormat(woDetails[0].PLAN_S_DATE)}
                    headerText="Planerad start"
                    jsonText=""
                  />
                </td>
                <td>
                  <LabelExistingWo
                    text={fixDateFormat(woDetails[0].PLAN_F_DATE)}
                    headerText="Planerad slut"
                    jsonText=""
                  />
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <LabelExistingWo
                    text={getParameterValue("8134")}
                    headerText="Order skapad av"
                    jsonText=""
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </>
      );
    }
  }
};

export default TabOverView;
